import { Spinner } from '@change/ds-core-ui';

import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { NewsAndGuidesListPagePrefetchedDataProps } from 'src/app/pages/newsAndGuides/list/pageContext';
import {
	NewsAndGuidesListPageContextProvider,
	prefetchPageContext,
} from 'src/app/pages/newsAndGuides/list/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';

import { Layout } from '../layout';

import { NewsAndGuidesListErrorHandler } from './ErrorHandler';

export const NewsAndGuidesList = withPrefetchedData(
	function NewsAndGuidesList({ prefetchedData }: NewsAndGuidesListPagePrefetchedDataProps) {
		const { countryCode } = useKnownAvailableParams<{ countryCode: string }>();
		const guides = useQueryParamValue('category') === 'guides';

		return (
			<NewsAndGuidesListPageContextProvider
				countryCode={countryCode}
				guides={guides}
				prefetchedData={prefetchedData}
				errorHandler={NewsAndGuidesListErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</NewsAndGuidesListPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) =>
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			prefetchPageContext(context.params.countryCode!, context.query.category === 'guides', context),
		// FIXME shouldn't those be different for guides?
		pageTitle: ({ i18n, fromTemplate }) => fromTemplate(i18n.translate('fe.pages.news_index.title')),
		pageMetadata: ({ i18n }) => ({
			description: i18n.translate('fe.pages.news_index.description'),
		}),
	},
);
